import Tab from "@mui/material/Tab";
import { Button, useTheme } from "@mui/material";
import "../index.css";
import { Close } from "@mui/icons-material";

export function TabItem({
  tabName,
  currentValue,
  index,
  onClick,
  buttonOnClick,
  ...props
}) {
  const selectedStatus = selected(currentValue, index);
  const theme = useTheme();
  const tabColor = selectedStatus
    ? theme.palette.common.white
    : theme.palette.text.primary;

  return (
    <div
      style={{ flexDirection: "row", display: "flex" }}
      className={`tabContainer-${selectedStatus ? "selected" : "unselected"}`}
    >
      <Tab
        label={
          <>
            <div>{tabName.props.children[0]}</div>
            <div>{tabName.props.children[2]}</div>
          </>
        }
        className={`tabItem-${selectedStatus ? "selected" : "unselected"}`}
        sx={{ color: tabColor }}
        onClick={() => onClick?.(index)} // 添加 onClick 處理
        {...props} // 傳遞其他 props
      ></Tab>

      <Button
        sx={{
          // width: `var(--button-size)`,
          minWidth: `var(--button-size)`,
          color: tabColor,
        }}
        className={`button-${selectedStatus ? "selected" : "unselected"}`}
        startIcon={<Close />}
        onClick={() => buttonOnClick?.(index)}
      ></Button>
    </div>
  );
}

function selected(currentValue, index) {
  if (currentValue === index) return true;
  else return false;
}
